import { create, GetState, SetState } from "zustand";

import {
  CustomerLead,
  LoanData,
  LoanTermsData,
  Sidebar,
  Store,
} from "./interface";

export const useUtilityStates = create<Store>(
  (set: SetState<Store>, get: GetState<Store>) => ({
    existingOffers: [],
    selectedOffer: {} as LoanData,
    offerCalculation: {} as LoanTermsData,
    sidebar: { isOpen: false, current: "" },
    customerData: {} as CustomerLead,
    setSidebar: (params: Sidebar) =>
      set((state) => ({ ...state, sidebar: params })),
    closeSidebar: () =>
      set((state) => ({
        ...state,
        existingOffers: [],
        selectedOffer: {} as LoanData,
        sidebar: { isOpen: false, current: "" },
      })),
    setExistingOffers: (params: LoanData[]) => {
      set((state) => ({
        ...state,
        existingOffers: params ?? [],
      }));
    },
    setSelectedOffer: (params: LoanData) => {
      set((state) => ({
        ...state,
        selectedOffer: params ?? [],
      }));
    },
    setOfferCalculation: (params: any) => {
      set((state) => ({
        ...state,
        offerCalculation: params ?? {},
      }));
    },
    setCustomerData: (params: CustomerLead) => {
      set((state) => ({
        ...state,
        customerData: params ?? [],
      }));
    },
  })
);
